// 🔧 running_event_day.js
// ✅ Purpose: Public-facing manager guide for running event day
// ✅ Features:
// - Provides a practical event-day checklist
// - Covers opening voting, helping attendees, monitoring activity, and publishing winners
// - Public and SEO-friendly
// - Uses the Dashboard-style LGV layout
// - Fully block-commented for clarity and future devs

import React from "react";
import { Link } from "react-router-dom";
import SeoHead from "../../../components/seo_head";

function RunningEventDayGuide() {
  return (
    <section id="top-content" className="container-fluid py-5">
      <SeoHead
        title="Running Event Day Guide | Let's Go Vote"
        description="Use this event-day checklist to open voting, support attendees, monitor activity, close voting, and publish winners with Let's Go Vote."
        path="/guides/running-event-day"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Guides", path: "/guides" },
          {
            name: "Running Event Day",
            path: "/guides/running-event-day",
          },
        ]}
      />
      <div className="row mb-4">
        <div className="col text-start">
          <h1 className="display-5">🏁 Running Event Day</h1>
          <p className="lead text-muted">
            A practical checklist for managing voting during your live event.
          </p>
        </div>
      </div>

      <div className="white-section p-4 rounded shadow-sm bg-white">
        <section className="mb-5">
          <div className="alert alert-info text-start">
            <h5 className="mb-3">Event day is where preparation pays off</h5>
            <p className="mb-0">
              Review your event setup, test your QR codes, monitor voting, and
              publish results when your event is ready.
            </p>
          </div>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Before opening voting</h3>
          <ol>
            <li>Confirm event dates and voting settings.</li>
            <li>Review categories and approved entries.</li>
            <li>Test QR codes from a phone.</li>
            <li>Confirm leaderboard and winner display settings.</li>
            <li>Make sure event staff know where to send attendees for help.</li>
          </ol>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">During the event</h3>
          <ol>
            <li>Help attendees scan QR codes.</li>
            <li>Remind voters to verify their email if needed.</li>
            <li>Monitor voting activity and entry visibility.</li>
            <li>Answer common questions using the Help Center.</li>
            <li>Keep printed QR signs visible and easy to scan.</li>
          </ol>
        </section>

        <section className="mb-5">
          <h3 className="mb-3">Closing voting</h3>
          <p>
            When voting is complete, review results, confirm any audit concerns,
            and prepare winners for public display. You can choose when winners
            and leaderboard information become visible.
          </p>
        </section>

        <section className="mb-0">
          <div className="alert alert-primary text-start mb-0">
            <h5 className="mb-3">Need help during setup?</h5>
            <p className="mb-3">
              The Help Center includes common answers for voters, participants,
              and event managers.
            </p>

            <Link to="/help" className="btn btn-primary">
              Visit Help Center
            </Link>
          </div>
        </section>
      </div>
    </section>
  );
}

export default RunningEventDayGuide;